import { createRouter, createWebHistory } from 'vue-router';

import shopLanding from './views/shopLanding.vue';
import catalogPage from './views/catalogPage.vue';
import contactPage from './views/contactPage.vue';
// import referencesPage from './views/referencesPage.vue';
import listingPage from './views/listingPage.vue';
import checkoutPage from './views/checkoutPage.vue';
import paymentPage from './views/paymentPage.vue';
import termsPage from './views/termsPage.vue';

import translation from './translation';

import logoutFetch from '@/apiFetches(old)/logoutFetch'

const availableLanguages = ['en', 'et']; // Define supported languages

// Reusable beforeEnter function
async function handleLocale(to, from, next) {
    const locale = to.params.locale;

    // Check if the locale is supported
    if (!availableLanguages.includes(locale)) {
        const pathWithoutLocale = to.fullPath.replace(/^\/[^/]+/, ''); // Remove invalid locale
        return next(`/et${pathWithoutLocale}`); // Redirect to /et with the same path structure
    }

    if (to.name === 'checkoutPage') {
        await logoutFetch();
    }

    // Load and set the locale
    await translation.loadLocale(locale);
    translation.setLocale(locale);

    next();
}

const routes = [
    // Redirect paths without a locale to the default locale
    { path: '/kataloog', redirect: '/et/kataloog' },
    { path: '/kontakteeru', redirect: '/et/kontakteeru' },
    // { path: '/referentsid', redirect: '/et/referentsid' },
    { 
        path: '/kuulutus/:id', 
        redirect: (to) => `/et/kuulutus/${to.params.id}` // Use a function to dynamically handle :id 
    },
    { 
        path: '/vormistamine/:idOrder', 
        redirect: (to) => `/et/vormistamine/${to.params.idOrder}` // Use a function to dynamically handle :idOrder
    },
    { 
        path: '/maksmine/:idOrder/:idDeal', 
        redirect: (to) => `/et/maksmine/${to.params.idOrder}/${to.params.idDeal}` // Use a function to dynamically handle params
    },

    // Routes with locales
    { path: '/:locale/', beforeEnter: handleLocale, component: shopLanding, name: 'shopLanding', props: true },
    { path: '/:locale/tingimused', beforeEnter: handleLocale, component: termsPage, name: 'termsPage', props: true },
    { path: '/:locale/kataloog', beforeEnter: handleLocale, component: catalogPage, name: 'catalogPage', props: true },
    { path: '/:locale/kontakteeru', beforeEnter: handleLocale, component: contactPage, name: 'contactPage', props: true },
    // { path: '/:locale/referentsid', beforeEnter: handleLocale, component: referencesPage, name: 'referencesPage', props: true },
    { path: '/:locale/kuulutus/:id', beforeEnter: handleLocale, component: listingPage, name: 'listingPage', props: true },
    { path: '/:locale/vormistamine/:idOrder', beforeEnter: handleLocale, component: checkoutPage, name: 'checkoutPage', props: true },
    { path: '/:locale/maksmine/:idOrder/:idDeal', beforeEnter: handleLocale, component: paymentPage, name: 'paymentPage', props: true },

    // Catch-all route for unsupported paths
    { path: '/:catchAll(.*)', redirect: '/et' },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition; // Scroll to saved position if available
        } else {
            return { top: 0 }; // Always scroll to top when navigating to a new page
        }
    },
});

export default router;
